<template>
    <div class="container main-wrapper">
        <div class="main">
            <NuxtPage />
        </div>
    </div>
</template>
<script>

export default {
    name: "EventOverview",

}
</script>

<style lang="scss" scoped>
.main-wrapper {
    display: flex;
    flex-direction: column;
    margin: 0 auto;
    height: 100vh;
}

.main {
    max-width: 1200px;
    margin: 0 auto;
    padding: 1rem 10px;
    min-height: 100%;
    width: 100%;

    @media (min-width: 768px) {
        padding: 2rem 20px;
    }
}
</style>
